module.exports = __webpack_public_path__ + "stylesheets/main-page_879611520604dcee108df2a231bfa0d9.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/main-page.less
// module id = dJ+1
// module chunks = 154